import { render, staticRenderFns } from "./ProductShippings.vue?vue&type=template&id=52e71506&"
import script from "./ProductShippings.vue?vue&type=script&lang=js&"
export * from "./ProductShippings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports